export const DEFAULT_FILTERS = [
    {
        key: 'TRANSACTION',
        display_name: 'Transaction',
    },
    {
        key: 'DATE',
        display_name: 'Date',
    },
    {
        key: 'MONTH',
        display_name: 'Month',
    },
];

export const FILTER_KEYS = {
    TRANSACTION: 'TRANSACTION',
    DATE: 'DATE',
    MONTH: 'MONTH',
    SUB_DEALER: 'SUB_DEALER',
    COUNTRY_STATE: 'COUNTRY_STATE',
};

export const NAVIGATION_TABS = {
    RESULTS: 'results',
    HISTORY: 'history',
};

export const REPORT_STATUS = {
    FAILED: 'FAILED',
    COMPLETED: 'COMPLETED',
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
};

export const ERROR_MESSAGES = {
    FETCH_COMMISSION_REPORTS_FAILED:
        "We're having trouble accessing the Commission results. Please try again in a few minutes.",
    FETCH_COMMISSION_REPORTS_HISTORY_FAILED:
        "We're having trouble accessing the Report history. Please try again in a few minutes.",
    DATE_RANGE_ERROR:
        'Please select a date range of 90 days or less for report generation',
    REPORT_DOWNLOAD_FAILED: 'Failed to download the report.',
    REPORT_GENERATE_FAILED: 'Failed to generate report.',
    GET_LATEST_STATUS_FAILED: 'Failed to get latest status',
};

export const SUCCESS_MESSAGES = {
    REPORT_GENERATED: 'Report generation started.',
    REPORT_DOWNLOADED: 'Report downloaded successfully',
    GET_LATEST_STATUS: 'Getting latest status...',
};

export const SNACKBAR_TYPES = {
    SUCCESS: 'success',
    FAILURE: 'failure',
};

export const ERROR_TYPES = {
    API_ERROR: 'API_ERROR',
    API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
};
